import React, { JSX, useEffect } from 'react';
import GlobalContextProvider from '../../../context/GlobalContextProvider';
import { toLocalStoragepageActive } from '../../../utils/functions';
import BackdropBlur from '../../atoms/backdrop-blur/BackdropBlur';
import FooterTransversal from '../../molecules/footer-transversal/FooterTransversal';
import Header from '../../molecules/header/header';
import MenuOffCanvas from '../../molecules/menu-offcanvas/MenuOffCanvas';
import Chat from '../Chat/Chat';
import './layout.scss';
import ServiceChannels from '../serviceChannels/ServiceChannel';

interface LayoutProps {
    children: JSX.Element | JSX.Element[];
}

const Layout = ({ children }: LayoutProps) => {
    useEffect(() => {
        toLocalStoragepageActive();
    }, []);

    return (
        <GlobalContextProvider>
            <div className="content">
                <Header />
                <MenuOffCanvas />
                <main className="o-main-container">{children}</main>
            </div>
            <FooterTransversal />
            <BackdropBlur />
            <ServiceChannels />
            <Chat />
        </GlobalContextProvider>
    );
};

export default Layout;
